'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _userDetails = require('./user-details.component');

var _userDetails2 = _interopRequireDefault(_userDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var userDetailsModule = _angular2.default.module('app.containers.user-details', []).config(function ($stateProvider) {
  "ngInject";

  $stateProvider.state('userDetails', {
    url: '/users/:userId',
    template: '<user-details></user-details>'
  });
}).component('userDetails', _userDetails2.default);

exports.default = userDetailsModule;


/** WEBPACK FOOTER **
 ** ./client/app/containers/user-details/user-details.js
 **/